import 'swiper/swiper.min.css';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as ISwiper } from 'swiper/types';
import tw from 'tailwind.macro';
import { Icon60 } from '../../../../components/Icon';
import { ReactComponent as IconChevron } from '../../../../images/chevronRightActive.svg';
import { Card } from './Cards';
import { DESTINATIONS, IDestination, SLIDER_PROPS } from './constants';

const SliderContainer = styled.div`
  ${tw`flex flex-col `}
  gap: var(--size-big);

  @media (min-width: 992px) {
    max-width: 60%;
  }

  .swiper {
    ${tw`w-full`}
  }
`;

const Control = styled.div`
  ${tw`flex items-center justify-center`}
  gap:var(--size-big)
`;

const Icon = styled(IconChevron)<{ reverse?: 0 | 1 }>`
  ${Icon60}

  #Oval-2 {
    fill: none;
  }

  ${({ reverse }) => reverse && 'transform: rotate(180deg)'}
`;

interface StepProps {
  active: boolean;
}

const Step = styled.span<StepProps>`
  ${tw`w-full rounded-15`}
  max-width:70px;
  ${({ active }) => (active ? tw`bg-green-500` : tw`bg-green-400`)}
`;

const Steps = styled.div`
  ${tw`hidden `}

  @media (min-width:420px) {
    ${tw`flex w-full justify-center`}

    max-width: 50%;
    gap: var(--size-small);
    height: var(--size-small);
  }
`;

interface SliderControlProps {
  currentIndex: number;
  swiperRef: React.MutableRefObject<ISwiper>;
}

const SliderControl: React.FC<SliderControlProps> = ({
  currentIndex,
  swiperRef,
}) => (
  <Control>
    <button onClick={() => swiperRef.current?.slidePrev()}>
      <Icon reverse={1} />
    </button>
    <Steps>
      {DESTINATIONS.map((i, index) => (
        <Step key={index} active={index === currentIndex} />
      ))}
    </Steps>
    <button onClick={() => swiperRef.current?.slideNext()}>
      <Icon />
    </button>
  </Control>
);

interface CitiesSliderProps {
  setCurrentSlideIndex: React.Dispatch<React.SetStateAction<number>>;
  swiperRef: React.MutableRefObject<ISwiper>;
}

const Slider: React.FC<CitiesSliderProps> = ({
  setCurrentSlideIndex,
  swiperRef,
}) => {
  const handleSlideChange = (swiper) => {
    setCurrentSlideIndex(swiper.realIndex);
  };

  return (
    <SliderContainer>
      <Swiper
        onSlideChange={handleSlideChange}
        {...SLIDER_PROPS}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {DESTINATIONS.map((destination: IDestination, index) => (
          <SwiperSlide key={index}>
            <Card data={destination} />
          </SwiperSlide>
        ))}
      </Swiper>
    </SliderContainer>
  );
};

export { Slider, SliderControl };
